import React, {Component} from "react";
import MobileLogoutButton from "../button/mobileLogoutButton";
import {getCurrentFlowChart} from "../../../utils/mobileUtils";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

class MobileMenu extends Component {
    constructor(props) {
        super();
    }

    onRowClick = (state, rowInfo, column, instance) => {
        return {
            onClick: e => {
                // console.log("A Td Element was clicked!");
                // console.log("it produced this event:", e);
                // console.log("It was in this column:", column);
                // console.log("It was in this row:", rowInfo);
                // console.log("It was in this table instance:", instance);

                const {flowChart, pushNewMenu, handleSynchroniseWebAppData} = this.props;
                let level = [...this.props.level];

                const selectedId = rowInfo.original.id;
                if (selectedId === null || selectedId === undefined) {
                    console.log("selectedId === null || selectedId === undefined");
                    return;
                }
                let newLevel = [...level, selectedId];
                const selectedFlowChart = getCurrentFlowChart(flowChart, newLevel);

                switch (selectedFlowChart.type) {
                    case "menu":
                        level = newLevel;
                        break;
                    case "back":
                        level.pop();
                        break;
                    case "synchronisation":
                        handleSynchroniseWebAppData()
                        break;
                    case "recording":
                    case "localBookingStorage":
                    case "systemConfiguration":
                    case "systemLog":
                    case "doorVisualisation":
                    case "shiftPlanning":
                    case "logisticsPlanning":
                    case "workPeriod":
                        level = newLevel;
                        break;
                    default:
                        console.log(
                            "MobileMenu.onRowClick(): case/default ",
                            selectedFlowChart.type
                        );
                        break;
                }

                pushNewMenu({
                    level: level,
                    flowChart: {...flowChart}
                });
            }
        };
    };

    onLogout = () => {
        this.props.handleLogout();
    };

    render = () => {
        const {level, currentFlowChart, credentials} = this.props;

        if (!currentFlowChart.menus) {
            return <React.Fragment></React.Fragment>;
        }

        let username = "unknown";
        if (
            credentials &&
            credentials.username &&
            credentials.username.length > 7 &&
            credentials.username.substring(6, 7) === "."
        ) {
            username = credentials.username.substring(7, credentials.username.length);
        } else {
            username = credentials.username;
        }
        const columns = [
            {
                // Header: level.length === 0 ? "Menü" : currentFlowChart.title.text,
                // Header: () => (
                //   <div style={{ textAlign: "center", height: "2em" }}>
                //     <strong>
                //       {level.length === 0 ? "Menü" : currentFlowChart.title.text}
                //     </strong>
                //   </div>
                // ),
                Header: (
                    <React.Fragment>
                        <h1>{level.length === 0 ? "Menü" : currentFlowChart.title.text}</h1>

                        <div
                            className="btn-toolbar justify-content-between"
                            role="toolbar"
                            aria-label="Toolbar with button groups"
                        >
                            <div className="btn-group" role="group" aria-label="First group">
                                <h4>User: {username}</h4>
                            </div>
                            <div className="btn-group" role="group" aria-label="Second group">
                                <div className="text-right">
                                    <MobileLogoutButton
                                        onClick={() => {
                                            this.onLogout();
                                        }}
                                        title={{text: "logout"}}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* <h4>
              expires_in:{" "}
              {credentials && credentials.expires_in
                ? credentials.expires_in
                : "0"}
            </h4> */}
                    </React.Fragment>
                ),
                accessor: "text"
                // Cell: props => <span className="number">{2}</span>
            }
        ];
        let data = [];
        for (const menuItem of currentFlowChart.menus) {
            data.push({id: menuItem.id, text: menuItem.title.text});
        }
        // console.log("MobileMenu.render(): data=", data);
        const ReactTableFixedColumns = withFixedColumns(ReactTable);

        const tightStyle = () => {
            return {
                style: {
                    fontSize: "xx-large"
                    // padding: "150",
                    // margin: "150"
                }
            };
        };

        return (
            <React.Fragment>
                <ReactTableFixedColumns
                    columns={columns}
                    data={data}
                    // defaultPageSize={data.length}
                    showPagination={false}
                    getTrProps={this.onRowClick}
                    showPageSizeOptions={true}
                    // getTheadThProps={tightStyle}
                    getTdProps={tightStyle}
                    //style={{ height: window.innerHeight }}
                    className="-striped"
                />
            </React.Fragment>
        );
    }
}

export default MobileMenu;
